var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          " Olá! Vamos pensar sobre os comportamentos observados no ambiente de trabalho? "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " Aqui você escreve os comportamentos que GOSTA de observar no seu ambiente de trabalho. "
        ),
      ]),
      _c("p", { staticClass: "success--text" }, [
        _vm._v(
          ' Por exemplo: "Estar sempre disposto a colaborar nas atividades que são realizadas na sua unidade." '
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " Aqui você escreve os comportamentos que NÃO GOSTA de observar no seu ambiente de trabalho. "
        ),
      ]),
      _c("p", { staticClass: "error--text" }, [
        _vm._v(
          ' Por exemplo: "Estar sempre apresentando dificuldades na realização de determinadas tarefas." '
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " Aqui você escreve os comportamentos IDEAIS para serem observados no seu ambiente de trabalho. "
        ),
      ]),
      _c("p", { staticClass: "warning--text" }, [
        _vm._v(
          ' Por exemplo: "Procurar aprender e conhecer o trabalho do colega de setor." '
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("ul", [
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(
                " Considere como “ambiente de trabalho” todas as unidades com as quais você interage para realizar seu trabalho; "
              ),
            ]
          ),
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(
                " Não se identifique nem indique de quem é o comportamento nas respostas. O sistema coletará todos os dados digitados, mas não registrará quem os inseriu; "
              ),
            ]
          ),
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(
                " Não há limite de descrições de comportamentos a serem registradas; "
              ),
            ]
          ),
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(
                " Só é necessário registrar a descrição do comportamento observado uma única vez, mesmo sendo identificado em duas ou mais pessoas. "
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }